module.exports = __webpack_public_path__ + "assets-cabinet/img/close_black_2048x2048.79891d26.png";